// removed by extract-text-webpack-plugin
module.exports = {"container":"_2J9rx7M9R85HMTggFEBLvk","title":"_3ANY2W25CpaB6CcvOLwRrU","logo":"_1_v9w0GHyRUdl-U-yRm9vV","fieldset":"_14mfCLLsSd2hSuY6Od7W3e","button":"_1n0tAqPXH85AbpQtScyUyG","error":"_3yUF0xMUUKRShe9tjC00ms"};


//////////////////
// WEBPACK FOOTER
// ./components/Login/styles.less
// module id = 1209
// module chunks = 0